<template>
  <mw-dialog ref="dialog" :appendToBody="false" :title="title" size="large_large"  :width="params.width ? params.width : ''" :height="params.height ? params.height : ''" class="process-chart-viewer-dialog">
    <!--<div class="mw-process-viewer">
      <div class="mw-process-chart">
        <MwProcessChartEditor :value="processDataGraph" :color="color" :editable="false" @requestTitle="handleRequestTitle" />
      </div>
      <div class="mw-process-chart-switch" v-if="processCount>1">
        <div class="_toolbar">
          <el-button class="el-button el-button&#45;&#45;primary" @click="processSwitchClick()"><i class="fa fa-eye"></i><span v-text="showProcessList?'隐藏流程列表':'查看流程列表'"></span></el-button>
        </div>
        <div class="_tab process-list" v-if="showProcessList">
          <el-card class="box-card">
            <template v-for="n in processList">
              <li class="_item" :class="{'active':(curFlowId==n.id)}" @click="processClick(n,$event)">
                <span class="label label-info" v-text="!n.isSub?'主':''"></span>
                <el-badge :is-dot="n.id==originalFlowId"><span v-html="n.name"></span></el-badge>
              </li>
            </template>
          </el-card>
        </div>
      </div>

    </div>-->
    <flow-chart-viewer :params="params" :parentObj="this"></flow-chart-viewer>
  </mw-dialog>
</template>


<script>
  export default {
    props: {
      params: Object
    },
    data() {
      return {
        title: "流程图",
      };
    },
    mounted() {
      this.$refs.dialog.show();
    }
  };
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/process-chart-viewer.vue